import { Resources } from '../ability';

interface Module {
  basename: string;
  resource: Resources;
  withSide: boolean;
  link?: string;
}

export type ModulesNames =
  | 'main'
  | 'news'
  | 'widgets'
  | 'process_catalog'
  | 'header'
  | 'sideMenu'
  | 'auth'
  | 'user'
  | 'create_certificate'
  | 'personal'
  | 'events'
  | 'dropdown_events'
  | 'paper'
  | 'candidates'
  | 'employees'
  | 'company'
  | 'policy'
  | 'absences'
  | 'payslips'
  | 'structure'
  | 'dropdown_settings'
  | 'settings'
  | 'event_types'
  | 'templates'
  | 'groups'
  | 'profiles'
  | 'substitutes'
  | 'settings_vacations'
  | 'attorneys'
  | 'attorneys_users'
  | 'sign_types'
  | 'social_news'
  | 'vacations'
  | 'competencies'
  | 'bell_notifications'
  | 'general_news'
  | 'social_categories'
  | 'social_access'
  | 'quiz'
  | 'review'
  | 'dropdown_social_services'
  | 'social_services'
  | 'company_services'
  | 'community'
  | 'feed'
  | 'social_life'
  | 'company_events'
  | 'employee_services'
  | 'search'
  | 'community'
  | 'surveys'
  | 'target_audience'
  | 'account'
  | 'widgets_content'
  | 'favorites'
  | 'business_trips';

export type ModulesConfig = Record<ModulesNames, Module>;

// eslint-disable-next-line local-rules/no-export-constants
export const modules: ModulesConfig = {
  main: {
    basename: 'dashboard',
    resource: 'Dashboard',
    link: '/',
    withSide: true,
  },

  widgets: {
    basename: '',
    resource: 'Dashboard',
    withSide: true,
  },

  process_catalog: {
    basename: 'process-catalog',
    resource: 'ProcessCatalog',
    link: '/process-catalog',
    withSide: true,
  },

  news: {
    basename: 'news',
    resource: 'News',
    link: '/news',
    withSide: true,
  },

  surveys: {
    basename: 'surveys',
    resource: 'Surveys',
    link: '/surveys',
    withSide: true,
  },

  target_audience: {
    basename: 'target-audience',
    resource: 'TargetAudience',
    link: '/company/target-audience',
    withSide: true,
  },

  social_life: {
    basename: 'social-life',
    resource: 'SocialLife',
    withSide: false,
  },

  community: {
    basename: 'community',
    resource: 'Community',
    link: '/community',
    withSide: true,
  },

  feed: {
    basename: 'feed',
    resource: 'Feed',
    link: '/feed',
    withSide: true,
  },

  sideMenu: {
    basename: 'sideMenu',
    resource: 'all',
    withSide: false,
  },

  header: {
    basename: 'header',
    resource: 'all',
    withSide: false,
  },

  auth: {
    basename: 'auth',
    resource: 'all',
    withSide: false,
  },

  user: {
    basename: 'profile',
    resource: 'User',
    withSide: false,
  },

  create_certificate: {
    basename: 'create-certificate',
    resource: 'User',
    withSide: false,
  },

  personal: {
    basename: 'personal',
    resource: 'Personal',
    link: '/personal',
    withSide: true,
  },

  business_trips: {
    basename: 'business-trips',
    resource: 'BusinessTrips',
    link: '/business-trips',
    withSide: true,
  },

  dropdown_events: { basename: 'events', resource: 'Events', withSide: true },

  company_events: {
    basename: '',
    resource: 'Events',
    link: '/events',
    withSide: true,
  },

  events: {
    basename: 'events',
    resource: 'Events',
    link: '/events',
    withSide: true,
  },

  paper: {
    basename: 'paper',
    resource: 'Events',
    withSide: true,
    link: '/company/events/paper',
  },

  review: {
    basename: 'review',
    link: '/review',
    resource: 'Review',
    withSide: true,
  },
  candidates: {
    basename: 'candidates',
    resource: 'Candidates',
    link: '/company/candidates',
    withSide: true,
  },

  employees: {
    basename: 'employees',
    resource: 'Employees',
    link: '/company/employees',
    withSide: true,
  },

  policy: {
    basename: 'policy',
    resource: 'Policy',
    link: '/policy',
    withSide: true,
  },

  absences: {
    basename: 'absences',
    resource: 'Absences',
    link: '/absences',
    withSide: true,
  },

  payslips: {
    basename: 'payslips',
    resource: 'Payslips',
    link: '/employee/payslips',
    withSide: true,
  },

  structure: {
    basename: 'organization',
    resource: 'Organization',
    link: '/organization',
    withSide: true,
  },

  settings: {
    basename: 'settings',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/company',
  },

  social_services: {
    basename: 'social-services',
    resource: 'SocialServices',
    withSide: true,
  },

  dropdown_social_services: {
    basename: 'social-services',
    resource: 'SocialServices',
    withSide: true,
  },

  dropdown_settings: {
    basename: 'settings',
    resource: 'Settings',
    withSide: true,
  },

  event_types: {
    basename: '',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/event-types',
  },

  templates: {
    basename: 'templates',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/templates',
  },

  groups: {
    basename: 'groups',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/groups',
  },

  profiles: {
    basename: 'profiles',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/profiles',
  },

  substitutes: {
    basename: 'substitutes',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/substitutes',
  },

  settings_vacations: {
    basename: 'vacations',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/vacations',
  },

  attorneys: {
    basename: 'attorneys',
    resource: 'Settings',
    link: '/company/settings/attorneys',
    withSide: true,
  },

  attorneys_users: {
    basename: 'attorneys-users',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/attorneys-users',
  },

  sign_types: {
    basename: 'sign-types',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/sign-types',
  },

  social_news: {
    basename: 'news',
    resource: 'News',
    link: '/company/news',
    withSide: true,
  },
  account: {
    basename: 'account',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/account',
  },
  company: {
    basename: 'company',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/company',
  },
  social_categories: {
    basename: 'social-categories',
    resource: 'Categories',
    link: '/company/social-categories',
    withSide: true,
  },
  quiz: {
    basename: 'quiz',
    resource: 'Quiz',
    withSide: true,
    link: '/company/quiz',
  },
  social_access: {
    basename: 'social-access',
    resource: 'SocialAccess',
    withSide: true,
    link: '/company/social-access',
  },
  vacations: {
    basename: 'vacations',
    resource: 'Vacations',
    link: '/vacations',
    withSide: true,
  },

  competencies: {
    basename: 'competencies',
    resource: 'Competencies',
    withSide: true,
    link: '/employee/competencies',
  },

  bell_notifications: {
    basename: 'notifications',
    resource: 'User',
    withSide: false,
  },

  company_services: {
    basename: 'dashboard.constants.companyServices',
    resource: 'CompanyServices',
    withSide: true,
  },

  employee_services: {
    basename: 'dashboard.constants.employeeServices',
    resource: 'EmployeeServices',
    withSide: true,
  },

  search: {
    basename: 'search',
    resource: 'Search',
    link: '/search',
    withSide: false,
  },

  general_news: {
    basename: 'news',
    resource: 'GeneralNews',
    link: '/news',
    withSide: true,
  },

  widgets_content: {
    basename: 'widgets-content',
    resource: 'Settings',
    withSide: true,
    link: '/company/settings/widgets-content',
  },

  favorites: {
    basename: 'favorites',
    resource: 'Favorites',
    link: '/favorites',
    withSide: true,
  },
};
